import React, { useEffect, useState } from "react";
import axios from "axios";
import { MyPieChart } from "../pieChart";
import "../../dashboardStyle/dashStock.css"; 

import { textAlign } from "@mui/system";
import useMediaQuery from "@mui/material/useMediaQuery";

import {DoughnutChartFiche} from "../fiche/fiche";
import {DoughnutChartFicheDem} from "../fiche/ficheDem";

import { DashStkTout } from "./dashPrincStoc";
import {DashRDC} from "./dashRDC";
import {DashETG} from "./dashEtage";
import {DashConteneurs} from "./dashConteneurs";

export const DashStk = () => {
  const apiUrl = process.env.REACT_APP_API_URL;



  //RDC
 


   //Etage



   //Etage
  

 
   const [totalLocation,setTotalLocation] =  useState(0);
   const [retardLocation,setRetardLocation] = useState(0);
   
 
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${apiUrl}IHM/api/dashboard.php?loc=enCours`);
        setTotalLocation(response.data.tt); 
        console.log("total des locations :", response.data.tt);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };
    fetchData();
  }, [apiUrl]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${apiUrl}IHM/api/dashboard.php?loc=retard`);
        setRetardLocation(response.data.retard);
        console.log("total des retards :", response.data.retard);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };
    fetchData();
  }, [apiUrl]);




 
  

 const isMobilePortrait = useMediaQuery("(max-width:1207px) ");
  return (
    <>
      {isMobilePortrait && (
        <div>
          <div>
            <br />
            <div className="Item">
              <DashStkTout dim="mob" />
            </div>

          </div>
          <div style={{ marginTop: "5%" }}>
            <div className="Item">
              <DashRDC
               
                dim="mob"
              />
            </div>


            <div className="Item">
              <DashETG dim="mob" />
            </div>
            <div className="Item">
              <DashConteneurs
               
                dim="mob"
              />
            </div>
          </div>
          <div className="pie-chart-container"></div>
        </div>
      )}
      {!isMobilePortrait && (
        <div className="dashboard-container">
         


          <div
            style={{
              display: "flex",
              justifyContent: "center", 
              alignItems: "flex-start",
              gap: "60px",
              marginTop: "40px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  marginBottom: "10px",
                }}
              >
                Fiches stock (j - 30)
              </div>
              <div style={{ width: "300px", height: "300px" }}>
                <DoughnutChartFiche title="Fiche" dim="p" />
              </div>
            </div>

            <div
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  marginBottom: "10px",
                }}
              >
                Fiches dem (j - 30)
              </div>
              <div style={{ width: "300px", height: "300px" }}>
                <DoughnutChartFicheDem title="Fiche Dem" dim="p" />
              </div>
            </div>
          </div>

 <div className="piePrincipal">
            {/* <span style={{ fontWeight: "900" }}>OCCUPATION</span> */}
  </div>

          <div
            className="containerDash"
            style={{
              marginTop: "5%",
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "30px",
              justifyContent: "center",
              justifyItems: "center",
            }}
          >
            <div className="Item">
              <DashStkTout dim="p" />
            </div>

            <div className="Item">
              <DashRDC
                
                dim="p"
              />
            </div>

            <div className="Item">
              <DashETG dim="p" />
            </div>

            <div className="Item">
              <DashConteneurs
                dim="p"
              />
            </div>
          </div>

        </div>
      )}
    </>
  );
};
